var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1082_13262)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37242 12C4.08065 12.7536 5.1253 13.792 6.60167 14.6219C6.21623 13.8298 6 12.9401 6 12C6 11.0599 6.21623 10.1702 6.60167 9.37809C5.1253 10.208 4.08065 11.2464 3.37242 12ZM18 12C18 12.9401 17.7838 13.8298 17.3983 14.6219C18.8747 13.792 19.9193 12.7536 20.6276 12C19.9193 11.2464 18.8747 10.208 17.3983 9.37809C17.7838 10.1702 18 11.0599 18 12ZM1.63326 10.9295C2.88924 9.55785 6.14709 6 12 6C17.8529 6 21.1107 9.55785 22.3667 10.9295L22.3667 10.9295C22.5038 11.0791 22.617 11.2028 22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071C22.617 12.7972 22.5038 12.9209 22.3667 13.0705L22.3667 13.0705C21.1107 14.4422 17.8529 18 12 18C6.14709 18 2.88924 14.4422 1.63326 13.0705L1.63325 13.0705C1.49623 12.9209 1.38303 12.7972 1.29289 12.7071C0.902369 12.3166 0.902369 11.6834 1.29289 11.2929C1.38303 11.2028 1.49623 11.0791 1.63325 10.9295L1.63326 10.9295ZM8 12C8 9.79086 9.79085 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79085 16 8 14.2091 8 12ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "#0864A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1082_13262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBlue);
export default __webpack_public_path__ + "static/media/ViewBlue.1415f15a2d0ea47c185ff213ad351884.svg";
export { ForwardRef as ReactComponent };